import {$, w} from './constants';
import { trackEvent } from "./gtm.js"; 

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatNumber(number) {
	return number.toLocaleString('en-US', {
		maximumFractionDigits: 1,
		notation: 'compact',
		compactDisplay: 'short'
	})
}

function formatNumberSemantic(number) {
	if (number >= 1_000_000) {
		const millions = number / 1_000_000;
		const fixed = millions.toFixed(1).replace(/\.0$/, '');
		const label = (fixed === '1' ? 'millón de pesos' : 'millones de pesos');
		return fixed + ' <span class="formatted">' + label + '</span>';
	} else {
		return numberWithCommas(parseInt(number)) + ' <span class="formatted">pesos</span>';
	}
}

// Toggle state of graph_input_JS when they have a value
function formatInputWithCaret(el) {
	const rawBefore = el.value;
	const caretPosBefore = el.selectionStart;

	let digitsBeforeCaret = 0;
	for (let i = 0, count = 0; i < caretPosBefore; i++) {
		if (/\d/.test(rawBefore[i])) count++;
		digitsBeforeCaret = count;
	}

	const raw = rawBefore.replace(/[^\d]/g, '');
	const formatted = numberWithCommas(raw);
	el.value = formatted;

	let newCaretPos = 0;
	let digitsSeen = 0;
	while (digitsSeen < digitsBeforeCaret && newCaretPos < formatted.length) {
		if (/\d/.test(formatted[newCaretPos])) digitsSeen++;
		newCaretPos++;
	}

	setTimeout(() => {
		el.setSelectionRange(newCaretPos, newCaretPos);
	}, 0);
}

// Format all inputs on load, *without* messing with caret (set caret to end)
document.querySelectorAll('.ret_input_JS').forEach(input => {
	const val = input.value || '';
	input.value = numberWithCommas(val.replace(/[^\d]/g, ''));
});

// Now add input listeners for formatting while typing
document.querySelectorAll('.ret_input_JS').forEach(input => {
	input.addEventListener('input', () => {
		if (input.value) {
			formatInputWithCaret(input);
			input.closest('div').classList.add('active');
			input.closest('div').classList.remove('error');
		} else {
			input.closest('div').classList.remove('active');
			input.closest('div').classList.add('error');
		}
	});
});


export function calcRetirement() {
	var obj = {};
	var error = false;
	var rate = 1.10;
	var rateRetired = 1.07;
	var final = 90;
	var zeroAge = null;
	
	var age = parseInt($('.graph_age_JS').val(), 10);
	var retirement = parseInt($('.graph_retirement_JS').val(), 10) - 1;
	
	var expenses = parseInt($('.graph_expenses_JS').val().replace(/,/g, ''), 10) * 12;
	var savings = parseInt($('.graph_savings_JS').val().replace(/,/g, ''), 10);
	var investment = parseInt($('.graph_investment_JS').val().replace(/,/g, ''), 10) * 12;

	$('.calc_ret_JS').find('input').each(function () {
		if ($(this).val() == '') {
			$(this).addClass('error');
			error = true;
			return;
		} else {
			$(this).removeClass('error');
		}
	});

	if (error === false) {
		var current = 1;
		var total = 0;
		var alt = 0;
		var period = retirement - age;
		obj['age' + age] = age;
		obj['tot' + age] = parseInt(savings);
		obj['alt' + age] = parseInt(savings);
		obj['exp' + age] = parseInt(expenses);
		for (current; current < period; current++) {
			if (current == 1) {
				total = savings;
				alt = savings;
				age++;
				expenses = expenses*1.04
				total = (total * rate) + investment;
				alt = (alt * rate) + investment*1.4;
				obj['age' + age] = age;
				obj['tot' + age] = parseInt(total);
				obj['alt' + age] = parseInt(alt);
				obj['exp' + age] = parseInt(expenses);
			}
			age++;
			expenses = expenses*1.04
			total = (total * rate) + investment;
			alt = (alt * rate) + investment*1.4;
			obj['age' + age] = age;
			obj['tot' + age] = parseInt(total);
			obj['alt' + age] = parseInt(alt);
			obj['exp' + age] = parseInt(expenses);
		}
		$('.graph_figure_1_JS').html('$'+formatNumberSemantic(obj['tot'+retirement]))
		$('.graph_figure_2_JS').html('$'+formatNumberSemantic(expenses))
		age++
		
		var cont = 0
		for (age; age <= final; age++) {
			expenses = expenses * 1.04;
			total = (total * rateRetired) - expenses;
			alt = (alt * rateRetired) - expenses;

			if (zeroAge === null && total <= 0) {
				zeroAge = age;
			}

			obj['age' + age] = age;
			obj['tot' + age] = parseInt(total);
			obj['alt' + age] = parseInt(alt);
			obj['exp' + age] = parseInt(expenses);
			cont++;
		}

		let totalRetirementExpenses = 0;
		for (let i=retirement;i<=final;i++) {
			if (obj['exp'+i]) {
				totalRetirementExpenses += obj['exp'+i];
			}
		}
		$('.graph_figure_3_JS').html('$'+formatNumberSemantic(totalRetirementExpenses));

		if (zeroAge === null) {
			$('.block_JS').removeClass('active')
			$('.block_txt_JS').html('Lo que proyectamos que tendrás <br>al momento de iniciar tu retiro')
			$('.graph_figure_1_JS').html('$'+formatNumberSemantic(obj['tot'+retirement]))
		} else {
			$('.block_JS').addClass('active')
			$('.block_txt_JS').html('En este escenario tus ahorros <br>se acabarán a la edad de')
			$('.graph_figure_1_JS').html(zeroAge+' <span>años</span>')
		}

		// Convert to C3 data format
		const ages = ['x'];
		const totals = ['Ahorro Base'];
		const alts = ['Ahorro Alternativo'];

		let totalHasDropped = false;

		Object.keys(obj).forEach((key) => {
			if (key.startsWith('age')) {
				const age = obj[key];
				const total = obj['tot' + age];
				const altValue = obj['alt' + age];

				ages.push(age);

				// If total is already zero or below, stop plotting further
				if (totalHasDropped || total <= 0) {
					totals.push(null); // null prevents the line from drawing further
					totalHasDropped = true;
				} else {
					totals.push(total);
				}

				if (altValue <= 0) {
					alts.push(null);
				} else {
					alts.push(altValue);
				}
			}
		});

		// let totalHasDropped = false;
		// let totalAllowOneMore = false;

		// let altHasDropped = false;
		// let altAllowOneMore = false;

		// Object.keys(obj).forEach((key) => {
		// 	if (!key.startsWith('age')) return;

		// 	const age = obj[key];
		// 	const total = obj['tot' + age];
		// 	const altValue = obj['alt' + age];

		// 	ages.push(age);

		// 	// ===== BASE SCENARIO =====
		// 	if (totalHasDropped) {
		// 		totals.push(null);
		// 	} else {
		// 		totals.push(total);

		// 		if (total <= 0) {
		// 			if (totalAllowOneMore) {
		// 				totalHasDropped = true;
		// 			}
		// 			totalAllowOneMore = true;
		// 		}
		// 	}

		// 	// ===== ALT SCENARIO =====
		// 	if (altHasDropped) {
		// 		alts.push(null);
		// 	} else {
		// 		alts.push(altValue);

		// 		if (altValue <= 0) {
		// 			if (altAllowOneMore) {
		// 				altHasDropped = true;
		// 			}
		// 			altAllowOneMore = true;
		// 		}
		// 	}
		// });

		// Generate the graph
		const chart = c3.generate({
			bindto: '#graph_JS',
			legend: { show: false },
			point: { show: false },
			color: { pattern: ['#424EE0', '#C8CBFB'] },
			tooltip: {
				format: {
					title: function (d) { return d + ' Años'; },
					value: function (d) { return '$'+formatNumber(d); }
				}
			},
			data: {
				x: 'x',
				columns: [ages, totals, alts],
				type: 'line',
			},
			padding: { left: 40, top: 0, bottom: 0, right: 5 },
			transition: {
				duration: 800
			},
			grid: {
				y: {
					show: true,
					lines: [
						{ value: 0, text: '', class: 'grid-zero' }
					]
				},
				x: {
					lines: [
						{ value: retirement, class: 'retirement-line' }
					]
				}
			},
			axis: {
				x: {
					label: 'Edad',
					tick: {
						fit: false,
						count: Math.floor((final - $('.graph_age_JS').val()) / 5) + 1,
						format: d => d % 5 === 0 ? d : ''
					}
				},
				y: {
					label: 'Ahorro',
					min: 0,
					tick: {
						format: d => '$' + formatNumber(d),
					},
				},
			},
			onrendered: function () {
				swapGridAndChartLayers()
			}
		});

		// Position the "Retiro" label
		function positionRetirementLabel() {
			const svg = document.querySelector('#graph_JS svg');
			const line = document.querySelector('#graph_JS .c3-xgrid-line.retirement-line line');
			const label = document.getElementById('retirementLabel');

			if (!svg || !line || !label) return;

			// SVG's rect relative to the viewport
			const svgRect = svg.getBoundingClientRect();

			// The element that the label's position will be relative to
			const parent = label.offsetParent || document.documentElement;
			const parentRect = parent.getBoundingClientRect();

			// X coordinate of the vertical line inside the SVG (in SVG user coords)
			const x = parseFloat(line.getAttribute('x1')) || 0;

			// Compute label position relative to the offsetParent
			// (viewport coords minus parent's viewport coords)
			const left = (svgRect.left - parentRect.left) + x - 39; // 8px gap to the right
			const top  = (svgRect.top  - parentRect.top) - 5;

			label.style.position = 'absolute'; // ensure absolute
			label.style.left = Math.round(left) + 'px';
			label.style.top  = Math.round(top)  + 'px';
		}

		positionRetirementLabel();
		window.addEventListener('resize', positionRetirementLabel);
		document.addEventListener('visibilitychange', positionRetirementLabel);

		// Swith orders of gridGroup after chartGroup
		function swapGridAndChartLayers() {
			const svg = document.querySelector('#graph_JS svg');
			if (!svg) return;

			const gridGroup = svg.querySelector('g.c3-grid.c3-grid-lines');
			const chartGroup = svg.querySelector('g.c3-chart');

			if (gridGroup && chartGroup && chartGroup.parentNode) {
				chartGroup.parentNode.insertBefore(gridGroup, chartGroup);
			}
		}

		// Print alternative monthly investment
		var newAlt = parseInt($('.graph_investment_JS').val().replace(/,/g,'')) * 1.4
		$('.graph_alt_JS').text(numberWithCommas(newAlt))

		// Fade-in effect
		setTimeout(() => {
			document.querySelector('#graph_JS').classList.add('chart-loaded');
		}, 100);

	}
}

// Handle add num inputs
$('.ret_num_add_JS').click(function () {
	let add = parseInt($(this).closest('.graph_num_JS').find('.ret_input_JS').val()) + 1
	let max = $(this).closest('.graph_num_JS').data('max')
	if (add <= max) {
		$(this).closest('.graph_num_JS').find('.ret_input_JS').val(add)
	}
})

// Handle sub num inputs
$('.ret_num_sub_JS').click(function () {
	let sub = parseInt($(this).closest('.graph_num_JS').find('.ret_input_JS').val()) - 1
	let min = $(this).closest('.graph_num_JS').data('min')
	if (sub >= min) {
		$(this).closest('.graph_num_JS').find('.ret_input_JS').val(sub)
	}
})

// Trigger Retirement Calculator
$('.graph_btn_JS').click(function () {
	calcRetirement()
})

